/* CompuMac Pflichtangaben im Shop (28.09.2026).
   1. EU-Energielabel als geschachtelte Anzeige (VO (EU) 2023/1669 bzw. 2019/2013, Anhang VIII Nr. 3): Klick oder
      Tippen auf den Pfeil zeigt das Etikett als Einblendung mit Schließen-Knopf; ohne JavaScript öffnet der Link
      das Etikett in einem neuen Tab.
   2. Beim Variantenwechsel Energielabel, Ladegerät-Angaben und Herstellerangaben der neuen Variante übernehmen (aus
      dem Abschnitt, den product-info.js ohnehin lädt).
   3. Denselben Pfeil neben die Preise der Kaufleiste (cm-purchase-bar) setzen, die Ladegerät-Angaben (EU 2022/2380)
      unter den Preis in „Deine Auswahl“; die Leiste selbst bleibt unberührt.
   4. Den Buchstaben im Pfeil auf die Schriftgröße des jeweiligen Preises bringen (Anhang VIII Nr. 2 b). */
(() => {
  if (window.cmCompliance) return;
  window.cmCompliance = true;

  // Texte in der Sprache der Seite: window.cmT.compliance aus snippets/cm-x-js-texts (Texte in snippets/cm-xt-js, Abschnitt compliance).
  // Fehlt cmT oder ein Schlüssel, gilt der deutsche Text hier; {name} wird ersetzt.
  const cmTexts = (window.cmT && window.cmT.compliance) || {};
  const tx = (key, de, vars) => {
    const own = cmTexts[key];
    const text = typeof own === 'string' && own && !/^(translation missing|\[text fehlt)/i.test(own) ? own : de;
    return vars ? text.replace(/\{(\w+)\}/g, (all, name) => (name in vars ? vars[name] : all)) : text;
  };

  const sized = (url, width) => {
    try {
      const u = new URL(url, window.location.href);
      if (/(^|\.)cdn\.shopify\.com$/.test(u.hostname) || u.pathname.includes('/cdn/shop/')) u.searchParams.set('width', String(width));
      return u.href;
    } catch (error) {
      return url;
    }
  };

  // --- 1. Einblendung ---------------------------------------------------------------------------------------
  let dialog = null;
  let image = null;
  let heading = null;
  let trigger = null;

  const ensureDialog = () => {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'cm-energy-dialog';
    dialog.setAttribute('aria-labelledby', 'CmEnergyDialogTitle');
    dialog.innerHTML = '<div class="cm-energy-dialog__bar"><p class="cm-energy-dialog__title" id="CmEnergyDialogTitle"></p><button type="button" class="cm-energy-dialog__close" data-cm-energy-close></button></div><img class="cm-energy-dialog__img" decoding="async" alt="">';
    dialog.querySelector('[data-cm-energy-close]').textContent = tx('close', 'Schließen');
    image = dialog.querySelector('img');
    heading = dialog.querySelector('.cm-energy-dialog__title');
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog || event.target.closest('[data-cm-energy-close]')) dialog.close();
    });
    dialog.addEventListener('close', () => {
      if (trigger && document.contains(trigger)) trigger.focus({ preventScroll: true });
    });
    document.body.appendChild(dialog);
    return dialog;
  };

  const openLabel = (link) => {
    ensureDialog();
    trigger = link;
    const box = link.closest('[data-cm-energy]');
    const size = box ? getComputedStyle(box).getPropertyValue('--cm-energy-size').trim() : '';
    dialog.style.setProperty('--cm-energy-size', size || '2.8rem');
    heading.textContent = tx('title', 'EU-Energielabel – {title}', { title: link.dataset.cmEnergyTitle || '' });
    image.alt = tx('alt', 'Energieeffizienzklasse {class}', { class: link.dataset.cmEnergyClass || '' });
    image.src = sized(link.href, 1000);
    dialog.showModal();
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-cm-energy-open]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (typeof HTMLDialogElement !== 'function' || typeof document.createElement('dialog').showModal !== 'function') return;
    event.preventDefault();
    openLabel(link);
  });

  // --- 4. Größe wie der Preis ---------------------------------------------------------------------------------
  const priceFor = (box) => {
    const mirror = box.closest('.cm-energy-mirror');
    if (mirror) return mirror.previousElementSibling;
    const slot = box.closest('[id^="CmEnergy-"]');
    if (slot) return document.getElementById(`price-${slot.id.slice('CmEnergy-'.length)}`)?.querySelector('.price');
    return box.closest('.card-information, .card__information, .quick-add-modal__content-info--bulk-details')?.querySelector('.price');
  };
  const sizeAll = () => {
    document.querySelectorAll('[data-cm-energy]').forEach((box) => {
      const price = priceFor(box);
      if (!price) return;
      const px = parseFloat(getComputedStyle(price).fontSize);
      if (px > 6 && px < 80) box.style.setProperty('--cm-energy-size', `${px}px`);
    });
  };

  // --- 3. Kaufleiste ------------------------------------------------------------------------------------------
  const mirrorPurchaseBars = () => {
    document.querySelectorAll('cm-purchase-bar[data-section]').forEach((bar) => {
      const source = document.getElementById(`CmEnergy-${bar.dataset.section}`)?.querySelector('[data-cm-energy]');
      [['[data-purchase-inline-price]', 'cm-energy-mirror--inline'], ['[data-purchase-dock-price]', 'cm-energy-mirror--dock']].forEach(([selector, modifier]) => {
        const price = bar.querySelector(selector);
        if (!price || !price.parentElement) return;
        let slot = price.nextElementSibling && price.nextElementSibling.classList.contains('cm-energy-mirror') ? price.nextElementSibling : null;
        if (!source) {
          if (slot) slot.remove();
          return;
        }
        if (!slot) {
          slot = document.createElement('div');
          slot.className = `cm-energy-mirror ${modifier}`;
          price.insertAdjacentElement('afterend', slot);
        }
        if (slot.innerHTML !== source.outerHTML) slot.innerHTML = source.outerHTML;
      });

      // Ladegerät-Angaben unter den Preis in „Deine Auswahl“ (nach dem Energielabel, falls es eins gibt).
      const charger = document.getElementById(`CmCharger-${bar.dataset.section}`)?.querySelector('[data-cm-charger]');
      const inline = bar.querySelector('[data-purchase-inline-price]');
      if (!inline || !inline.parentElement) return;
      let chargerSlot = bar.querySelector('.cm-charger-mirror');
      if (!charger) {
        if (chargerSlot) chargerSlot.remove();
        return;
      }
      const after = inline.nextElementSibling && inline.nextElementSibling.classList.contains('cm-energy-mirror') ? inline.nextElementSibling : inline;
      if (!chargerSlot) {
        chargerSlot = document.createElement('div');
        chargerSlot.className = 'cm-charger-mirror';
      }
      if (after.nextElementSibling !== chargerSlot) after.insertAdjacentElement('afterend', chargerSlot);
      if (chargerSlot.innerHTML !== charger.outerHTML) chargerSlot.innerHTML = charger.outerHTML;
    });
  };

  // --- 2. Variantenwechsel ------------------------------------------------------------------------------------
  const swap = (html, id) => {
    const current = document.getElementById(id);
    const next = html && html.getElementById(id);
    if (!current || !next) return;
    const wasOpen = current.querySelector('details[open]') !== null;
    current.innerHTML = next.innerHTML;
    if (wasOpen) current.querySelector('details')?.setAttribute('open', '');
  };

  const refresh = () => {
    mirrorPurchaseBars();
    sizeAll();
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const data = event && event.data;
      if (!data || !data.sectionId) return;
      swap(data.html, `CmEnergy-${data.sectionId}`);
      swap(data.html, `CmCharger-${data.sectionId}`);
      swap(data.html, `CmGpsr-${data.sectionId}`);
      refresh();
    });
  }

  let resizeFrame = 0;
  window.addEventListener('resize', () => {
    cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(sizeAll);
  });
  document.addEventListener('shopify:section:load', refresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
  window.addEventListener('load', sizeAll);
})();
